import {
  Directive,
  ElementRef,
  Inject,
  Input,
  NgZone,
  Optional,
  ViewContainerRef,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS as MAT_TOOLTIP_DEFAULT_OPTIONS,
  MAT_LEGACY_TOOLTIP_SCROLL_STRATEGY as MAT_TOOLTIP_SCROLL_STRATEGY,
  MatLegacyTooltip as MatTooltip,
  MatLegacyTooltipDefaultOptions as MatTooltipDefaultOptions,
} from '@angular/material/legacy-tooltip';
import { Overlay, ScrollDispatcher } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { AriaDescriber, FocusMonitor } from '@angular/cdk/a11y';
import { Directionality } from '@angular/cdk/bidi';

@Directive({
  selector: '[mwToolTip]',
  exportAs: 'mwToolTip',
})
export class MwToolTipDirective extends MatTooltip implements OnInit {
  @Input()
  get mwToolTip(): string {
    return this.message;
  }
  set mwToolTip(value: string) {
    this.message = value;
  }

  private el: ElementRef;

  constructor(
    overlay: Overlay,
    elementRef: ElementRef,
    scrollDispatcher: ScrollDispatcher,
    viewContainerRef: ViewContainerRef,
    ngZone: NgZone,
    platform: Platform,
    ariaDescriber: AriaDescriber,
    focusMonitor: FocusMonitor,
    @Inject(MAT_TOOLTIP_SCROLL_STRATEGY) scrollStrategy: any,
    @Optional() dir: Directionality,
    @Optional()
    @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
    defaultOptions: MatTooltipDefaultOptions,
    private renderer: Renderer2
  ) {
    super(
      overlay,
      elementRef,
      scrollDispatcher,
      viewContainerRef,
      ngZone,
      platform,
      ariaDescriber,
      focusMonitor,
      scrollStrategy,
      dir,
      defaultOptions,
      null
    );
    this.el = elementRef;
  }

  ngOnInit(): void {
    if (this.el.nativeElement) {
      const elementToApply = this.el.nativeElement;
      const tooltip = this.renderer.createElement('div');
      const icon = this.renderer.createText('help_outline');
      this.renderer.addClass(tooltip, 'mw-tooltip');
      this.renderer.appendChild(tooltip, icon);
      this.renderer.appendChild(elementToApply, tooltip);
    }
  }
}
